module.exports = __webpack_public_path__ + "static/media/Artboard8.b46dc0ff.png";